import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import { useParams } from "react-router-dom";
import Switch from "react-switch";
import SvgImage from "../../../Icons/Icons";
import { toast } from "react-toastify";
import { sendAnalitics } from "../../../../services/Store/Actions/appActions";
import {
  editControlManager,
  managerGetControlAction,
} from "../../../../services/Store/Actions/UserManagementAction";
import ChangeTransferLimit from "../ChangeTransferLimit";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { ClipLoader } from "react-spinners";
import {
  getWalletBalAction,
  transactionHistory,
} from "../../../../services/Store/Actions/LogipeCardActions";
import { newGetCardControlAction } from "../../../../services/Store/Actions/driverslistActions";
import CardControlsModal from "../../../Modals/CardControlsModal";
import YesbankCard from "../../../ManageDriverV2/SubComponents/NeoCredCard";
import ManageDriverAddBalance from "../../../Modals/ManageDriverAddBalance";
import ManageDriverWithdrawBalance from "../../../Modals/ManageDriverWithdrawBalance";
import CardTable from "../../../ManageDriverV2/SubComponents/CardTable";
import { Button } from "reactstrap";
function CustomerManagerDetails(props) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(-1);
  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const { managerControlList, loader: managerLoader } = useSelector(
    (state) => state?.userManagement
  );
  const [selected, setSelected] = useState(0);
  console.log(managerControlList);
  const balanceRecord = useSelector(
    (state) => state?.LogipeCard?.balanceRecord
  );
  console.log("jjkksjsj", balanceRecord,balanceRecord?.accountStatus < 3);
  let { id } = useParams();
  useEffect(() => {
    if (id !== undefined) {
      dispatch(managerGetControlAction({ userId: id }));
      dispatch(getWalletBalAction(id));
      dispatch(newGetCardControlAction(id));
    } else {
    }
  }, [props.user,reload]);

  const marks = [
    {
      value: 0,
      label: "disable",
    },
    {
      value: 1,
      label: "view",
    },
    {
      value: 2,
      label: "edit",
    },
    {
      value: 3,
      label: "create",
    },
  ];
  function valuetext(value) {
    return `${
      value == 0
        ? "disable"
        : value == 1
        ? "view"
        : value == 2
        ? "edit"
        : value == 3
        ? "create"
        : "disable"
    }`;
  }

  const ManagerName = id ? props?.user?.fullName : "Select Manager";

  function handleClose() {
    setOpen(false);
  }
  function handleShow() {
    setOpen(true);
  }
  function toggleModal() {
    setOpen(!open);
  }
  const handleToggle = (e, item) => {
    if (loader == -1) {
      setLoader(item.type);
      dispatch(
        editControlManager(
          {
            userId: id,
            type: item.type,
          },
          (res) => {
            console.log("res", res);
            setLoader(-1);
            if (res?.type == "success") {
              dispatch(managerGetControlAction({ userId: id }));
            }
          }
        )
      );
    }
  };
  const handleSlide = (e, item) => {
    if (loader == -1) {
      setLoader(item.type);
      dispatch(
        editControlManager(
          {
            userId: id,
            type: item.type,
            value: e.target.value,
          },
          (res) => {
            console.log("res", res);
            setLoader(-1);
            if (res?.type == "success") {
              dispatch(managerGetControlAction({ userId: id }));
            }
          }
        )
      );
    }
  };
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };
  const toggleModal2 = () => {
    setOpen2(!open2);
  };
  const showModal2 = () => {
    setOpen2(true);
  };
  //handle add to card transfer
  const [open3, setOpen3] = useState(false);
  const handleClose3 = () => {
    setOpen3(false);
  };
  const toggleModal3 = () => {
    setOpen3(!open3);
  };
  const showModal3 = () => {
    setOpen3(true);
  };
  const [open4, setOpen4] = useState(false);
  const handleClose4 = () => {
    setOpen4(false);
  };
  const toggleModal4 = () => {
    setOpen4(!open4);
  };
  const showModal4 = () => {
    setOpen4(true);
  };
  const [open5, setOpen5] = useState(false);
  const handleClose5 = () => {
    setOpen5(false);
  };
  const toggleModal5 = () => {
    setOpen5(!open5);
  };
  const showModal5 = () => {
    setOpen5(true);
  };
  const controls = [
    {
      title: "Manager Limit",
      svgName: "accountStatus",
      width: 36,
      height: 36,
      type: "branchManager",
    },
    {
      title: "Transfer Access",
      svgName: "accountStatus",
      width: 36,
      height: 36,
      type: "transfer",
    },
    {
      title: "Master Account",
      svgName: "ManagerMasterAcc",
      width: 36,
      height: 36,
      type: "masterAccount",
    },
    {
      title: "Card",
      svgName: "ManagerCard",
      width: 36,
      height: 36,
      type: "wallet",
    },
    {
      title: "Vehicles",
      svgName: "ManagerFastag",
      width: 36,
      height: 36,
      type: "fastag",
    },
    // {
    //   title: "UPI",
    //   svgName: "UPI",
    //   width: 22,
    //   height: 22,
    //   type: "upi",
    // },
    {
      title: "Cashback",
      svgName: "ManagerCashback",
      width: 36,
      height: 36,
      type: "cashBack",
    },
    // {
    //   title: 'Customers',
    //   svgName: 'ManagerCustomers',
    //   width: 36,
    //   height: 36,
    //   type: 'customer',
    // },
    {
      title: "Scan And Pay",
      svgName: "ManagerUPI",
      width: 36,
      height: 36,
      type: "scanAndPay",
    },
    // {
    //   title: "Trips",
    //   svgName: "ManagerTrips",
    //   width: 18,
    //   height: 20,
    //   type: "trips",
    // },
    // {
    //   title: "Insurance",
    //   svgName: "insuranceV2",
    //   width: 21,
    //   height: 18,
    //   type: "insurance",
    // },
    // {
    //   title: "Logimart",
    //   svgName: "logimartV2",
    //   width: 18,
    //   height: 18,
    //   type: "ecom",
    // },
    // {
    //   title: "Load Money",
    //   svgName: "loadMoney",
    //   width: 18,
    //   height: 18,
    //   type: "loadMoney",
    // },
    // {
    //   title: "Customers",
    //   svgName: "customerV3",
    //   width: 18,
    //   height: 18,
    //   type: "customer",
    // },
    {
      title: "Salary Wallet",
      svgName: "salaryWallet",
      width: 18,
      height: 18,
      type: "salaryWallet",
    },
    {
      title: "Scan and pay from MA",
      svgName: "salaryWallet",
      width: 18,
      height: 18,
      type: "scanAndPayMA",
    },
    {
      title: "Bulk Transfer",
      svgName: "salaryWallet",
      width: 18,
      height: 18,
      type: "bulkTransfer",
    },
    {
      title: "Trips/LR Access",
      svgName: "stepView",
      width: 18,
      height: 18,
      type: "tripAccess",
    },
    {
      title: "Customer/Invoice Access",
      svgName: "stepView",
      width: 18,
      height: 18,
      type: "customerAccess",
    },
    {
      title: "Vendor Access",
      svgName: "stepView",
      width: 18,
      height: 18,
      type: "vendorAccess",
    },
    {
      title: "Admin Access",
      svgName: "stepView",
      width: 18,
      height: 18,
      type: "admin",
    },
    // {
    //   title: 'Trips',
    //   svgName: 'ManagerTrips',
    //   width: 36,
    //   height: 36,
    //   type: 'trips',
    // },
  ];
  useEffect(() => {}, [ManagerName]);
  return (
    <>
      {ManagerName === "Select Manager" ? (
        <div>
          <SvgImage name="managerDashboard" />
        </div>
      ) : (
        <div
          className="main-customer-vehicle-detail"
          style={{ opacity: ManagerName === "Select Manager" ? "0.5" : "1" }}
        >
          <div
            className="ManageCustomerDashboardContactCard"
            style={{ padding: "24px 25px 0px 36px" }}
          >
            <div className="contentMiddle flexRow">
              <div className="">
                <div className="vehicle-no FontSuperBold">
                  {ManagerName == "" || ManagerName == null
                    ? "Select Manager"
                    : ManagerName?.toUpperCase()}
                </div>
              </div>
              {/* <div className="Bar"></div>
          <div className="number FontNB">
            Phone :{" "}
            {props?.user?.phone === "" || props?.user?.phone == null
              ? "N/A"
              : props?.user?.phone}
          </div> */}
              <div className="flex1 d-flex justify-content-end">
                {/* <button
              className="d-flex"
              style={{
                marginRight: 36,
                backgroundColor: "white",
                borderWidth: 0,
              }}
              onClick={handleShow}
            >
              <div className="number FontNB me-1" style={{ color: "#2E7C7B" }}>
                {"₹ " + managerControlList?.transferLimit}
              </div>
              <SvgImage name="editLogo" width="22" height="22" />
            </button> */}
              </div>
            </div>
          </div>
          <div className="row" style={{ margin: "15px 0 0px 0" }}>
            <div className="col-md-6" style={{ padding: "5px 18px 5px 34px" }}>
              <div
                className="cardInfo3"
                // style={{margin: "20px 0px 30px 0px"}}
              >
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="driverHeader" style={{ color: "#4D5073" }}>
                    Card Balance
                  </div>
                  {balanceRecord?.accountStatus == 4 ? (
                    <div
                      style={{ fontSize: 12, cursor: "pointer" }}
                      onClick={showModal5}
                    >
                      Details <SvgImage name="rightArrow" />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="driverHeader">
                  {balanceRecord?.accountStatus < 3
                    ? "No card"
                    : balanceRecord?.accountStatus == 3
                    ? "Card Not Linked"
                    : balanceRecord?.balance === null
                    ? "₹ 0"
                    : "₹ " + balanceRecord?.balance}
                </div>
                {/* <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <button
                    className={"cardButton"}
                    style={{ color: "#FFFFFF" }}
                    onClick={showModal3}
                    disabled={balanceRecord?.accountStatus == 4 ? false : true}
                  >
                    Recharge
                  </button>
                  <button
                    className={"cardButton"}
                    style={{ color: "#FFFFFF" }}
                    onClick={showModal2}
                    disabled={balanceRecord?.accountStatus == 4 ? false : true}
                  >
                    Withdraw
                  </button>
                </div> */}

                {balanceRecord?.accountStatus == 4 ? (
                  <div
                    className="flexStyling"
                    style={{ justifyContent: "space-between" }}
                  >
                    <button
                      className={"cardButton"}
                      style={{ color: "#FFFFFF" }}
                      onClick={showModal3}
                      disabled={
                        balanceRecord?.accountStatus == 4 ? false : true
                      }
                    >
                      Recharge
                    </button>
                    <button
                      className={"cardButton"}
                      style={{ color: "#FFFFFF" }}
                      onClick={showModal2}
                      disabled={
                        balanceRecord?.accountStatus == 4 ? false : true
                      }
                    >
                      Withdraw
                    </button>
                  </div>
                ) : balanceRecord?.accountStatus < 3 ||
                  balanceRecord?.accountStatus > 7 ? (
                  <div style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      className="col-5 Button9"
                      onClick={() => {
                        let tmp = ManagerName?.split(" ");
                        console.log("jjishihihsihsei", tmp);
                        props.setUserIdFix({
                          userId: id,
                          firstName: tmp[0],
                          lastName: tmp.length < 2 ? "" : tmp[tmp?.length - 1],
                          phone: props?.user?.phone,
                        });
                        props.showModalAddDriver();
                      }}
                    >
                      Complete Min KYC
                    </Button>
                  </div>
                ) : balanceRecord?.accountStatus == 6 ? (
                  <div style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      className="col-5 Button9"
                      style={{ width: "250px" }}
                    >
                      Min KYC Completed. Proceed with Full KYC on LogiPe App
                    </Button>
                  </div>
                ) : balanceRecord?.accountStatus == 3 ? (
                  <Button
                    type="submit"
                    className="col-5 Button9"
                    style={{ width: "250px" }}
                  >
                    KYC Completed. Proceed with Link Card on LogiPe App
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="col-md-6" style={{ padding: "5px 34px 5px 18px" }}>
              <div className="cardInfo3">
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="driverHeader" style={{ color: "#4D5073" }}>
                    Details
                  </div>
                  <div
                    style={{ fontSize: 12, cursor: "pointer" }}
                    onClick={showModal4}
                  >
                    Details
                    <SvgImage name="rightArrow" />
                  </div>
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNM16">Branch</div>
                  {props?.user?.Branch ? (
                    <div className="fontNM16">
                      {props?.user?.Branch?.branchName}
                    </div>
                  ) : null}
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNM16">Limit Type/Utilised</div>
                  
                    <div className="fontNM16">
                      {managerControlList?.limitType == 0 ? `One Time/₹${managerControlList?.transferLimitUtilised}`: managerControlList?.limitType == 1 ? `Daily/₹${managerControlList?.transferLimitUtilised}` : `Monthly/₹${managerControlList?.transferLimitUtilised}`}
                    </div>
                  
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNM16">Manager Limit</div>
                  <div className="fontNM16" onClick={handleShow}>
                    {"₹ " + (parseFloat(managerControlList?.transferLimit))}{" "}
                    <SvgImage name="editLogo" width="22" height="22" />
                  </div>
                </div>
               
               
                
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNM16">Phone</div>
                  <div className="fontNM16">{props?.user?.phone}</div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-3 align-self-center" style={{ padding: "5px" }}>
          <button
            className={"cardButton"}
            style={{ color: "#FFFFFF", width: "180px" }}
            onClick={showModal3}
            disabled={balanceRecord?.accountStatus == 4 ? false : true}
          >
            All Transactions
          </button>
        </div> */}
          </div>
          <div className="flexStyling" style={{ padding: "20px 0 0 33px" }}>
            <button
              className={selected == 0 ? "ButtonNew" : "ButtonNewInactive"}
              onClick={() => setSelected(0)}
            >
              Controls
            </button>
            <button
              className={selected == 1 ? "ButtonNew" : "ButtonNewInactive"}
              onClick={() => setSelected(1)}
            >
              Transactions
            </button>
            {/* <button
              className={selected == 3 ? "ButtonNew" : "ButtonNewInactive"}
              onClick={() => setSelected(3)}
            >
              Salary & Incentive
            </button> */}
          </div>
          {/* <div className="padding16 row"> */}
          <div
            className="boxTxn1"
            style={{ marginRight: "15px", marginLeft: "32px" }}
          >
            {selected === 1 ? (
              <CardTable selected={selected} userId={id} />
            ) : selected === 0 ? (
              <div className="main-container-vehicle-details d-flex flex-wrap justify-content-around">
                {controls?.map((item, index) => {
                  return (
                    <div
                      className="auto-recharge padding16 "
                      style={{
                        marginTop: "1rem",
                        opacity:
                          managerControlList?.[item.type] == undefined
                            ? "0.5"
                            : "1",
                        width: "45%",
                      }}
                    >
                      <div className="row">
                        <div
                          className="col-6 semiBold heading2"
                          style={{ display: "flex", direction: "row" }}
                        >
                          <div style={{ paddingRight: "8px" }}>
                            <SvgImage name="svgName" />
                          </div>
                          {item.title}
                        </div>
                        <div
                          className={
                            managerControlList?.[item.type]
                              ? "col-6 row fontCardControl btnActive"
                              : "col-6 row fontCardControl btnInactive"
                          }
                          style={{
                            color: "#2E7C7B",
                            alignItems: "right",
                            // paddingLeft: "20px",
                            // marginTop: "10px",
                          }}
                        >
                          <div className="col-8"></div>
                          {console.log(
                            "dasfghwqeqwewqeqwewq",
                            item?.type,
                            managerControlList?.[item?.type],
                            loader
                          )}
                          {item?.svgName == "stepView" ? (
                            <Box sx={{ width: 200 }}>
                              {loader != item?.type ? (
                                managerControlList?.[item?.type] ? (
                                  <Slider
                                    aria-label="Always visible"
                                    // defaultValue={managerControlList?.[item?.type]}
                                    // getAriaValueText={valuetext}
                                    onChange={(val) => {
                                      console.log(val, "vaaaaa");
                                      // setTrip(val.target.value);
                                      handleSlide(val, item);
                                    }}
                                    value={managerControlList?.[item?.type]}
                                    min={0}
                                    max={3}
                                    // name={marks.filter((i) => i.value == trip)[0]?.label}
                                    step={1}
                                    marks={marks}
                                    classes={{
                                      colorPrimary: "rgb(46, 124, 123)",
                                      thumbColorPrimary: "rgb(46, 124, 123)",
                                    }}
                                    // valueLabelDisplay="on"
                                    size={"large"}
                                    sx={{
                                      "& .MuiSlider-thumb": {
                                        color: "rgb(46, 124, 123)",
                                      },
                                      "& .MuiSlider-track": {
                                        color: "rgb(46, 124, 123)",
                                      },
                                      "& .MuiSlider-rail": {
                                        color: "rgb(46, 124, 123)",
                                      },
                                      "& .MuiSlider-active": {
                                        color: "rgb(46, 124, 123)",
                                      },
                                    }}
                                  />
                                ) : (
                                  <Slider
                                    aria-label="Always visible"
                                    // defaultValue={managerControlList?.[item?.type]}
                                    // getAriaValueText={valuetext}
                                    onChange={(val) => {
                                      console.log(val, "vaaaaa");
                                      // setTrip(val.target.value);
                                      handleSlide(val, item);
                                    }}
                                    value={0}
                                    min={0}
                                    max={3}
                                    // name={marks.filter((i) => i.value == trip)[0]?.label}
                                    step={1}
                                    marks={marks}
                                    classes={{
                                      colorPrimary: "rgb(46, 124, 123)",
                                      thumbColorPrimary: "rgb(46, 124, 123)",
                                    }}
                                    // valueLabelDisplay="on"
                                    size={"large"}
                                    sx={{
                                      "& .MuiSlider-thumb": {
                                        color: "rgb(46, 124, 123)",
                                      },
                                      "& .MuiSlider-track": {
                                        color: "rgb(46, 124, 123)",
                                      },
                                      "& .MuiSlider-rail": {
                                        color: "rgb(46, 124, 123)",
                                      },
                                      "& .MuiSlider-active": {
                                        color: "rgb(46, 124, 123)",
                                      },
                                    }}
                                  />
                                )
                              ) : (
                                // <Slider
                                //   aria-label="Always visible"
                                //   // defaultValue={managerControlList?.[item?.type]}
                                //   // getAriaValueText={valuetext}
                                //   onChange={(val) => {
                                //     console.log(val, "vaaaaa");
                                //     // setTrip(val.target.value);
                                //   }}
                                //   min={0}
                                //   max={3}
                                //   // name={marks.filter((i) => i.value == trip)[0]?.label}
                                //   step={1}
                                //   marks={marks}
                                //   classes={{
                                //     colorPrimary: "rgb(46, 124, 123)",
                                //     thumbColorPrimary: "rgb(46, 124, 123)",
                                //   }}
                                //   // valueLabelDisplay="on"
                                //   size={"large"}
                                //   sx={{
                                //     "& .MuiSlider-thumb": {
                                //       color: "rgb(46, 124, 123)",
                                //     },
                                //     "& .MuiSlider-track": {
                                //       color: "rgb(46, 124, 123)",
                                //     },
                                //     "& .MuiSlider-rail": {
                                //       color: "rgb(46, 124, 123)",
                                //     },
                                //     "& .MuiSlider-active": {
                                //       color: "rgb(46, 124, 123)",
                                //     },
                                //   }}
                                // />
                                <ClipLoader
                                  color={"#2E7C7B"}
                                  loading={true}
                                  size={20}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />
                              )}
                            </Box>
                          ) : (
                            <Switch
                              checked={managerControlList?.[item.type]}
                              onChange={(e) => {
                                handleToggle(e, item);
                              }}
                              onColor="#EBF2F2"
                              onHandleColor="#2E7C7B"
                              handleDiameter={20}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              height={15}
                              width={40}
                              className="react-switch col-4"
                              id="material-switch"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <></>
            )}
          </div>
          {/* </div> */}
          {open4 ? (
            <CardControlsModal
              userId={id}
              open={open4}
              toggleModal={toggleModal4}
              title="Logipe Account"
              handleClose={handleClose4}
              cardType={"1"}
              accountStatus={balanceRecord?.accountStatus}
              authUser={props.authUser}
            />
          ) : null}
          {
                    open ?         <ChangeTransferLimit
                            open={open}
                            handleClose={handleClose}
                            toggleModal={toggleModal}
                            user={props.user}
                            setReload={setReload}
                            reload = {reload}
                            limitType={managerControlList?.limitType}
                          /> : <></>
          }
          {open5 ? (
            <YesbankCard
              open={open5}
              onHide={toggleModal5}
              // remarks={`Incentive Paid for Trip ${tripData?.tripNo}`}
              toggleModal={toggleModal5}
              handleClose={handleClose5}
              userId={id}
              driverCardStatus={balanceRecord?.accountStatus}
              driverDetails={ManagerName}
            />
          ) : null}
          <ManageDriverAddBalance
            open={open3}
            toggleModal={toggleModal3}
            handleClose={handleClose3}
            name="Add Balance"
            userId={id}
            driverBal={balanceRecord?.balance}
            cardType={1}
            driverName={ManagerName}
          />

          <ManageDriverWithdrawBalance
            open={open2}
            toggleModal={toggleModal2}
            handleClose={handleClose2}
            name="Withdraw Balance"
            userId={id}
            driverBal={balanceRecord?.balance}
            cardType={1}
            driverDetails={{ name: ManagerName }}
            driverName={ManagerName}
          />
        </div>
      )}
    </>
  );
}
export default CustomerManagerDetails;
